import { render, staticRenderFns } from "./eliminarLista.vue?vue&type=template&id=33ea96da&scoped=true&lang=html&"
import script from "./eliminarLista.vue?vue&type=script&lang=js&"
export * from "./eliminarLista.vue?vue&type=script&lang=js&"
import style0 from "./eliminarLista.vue?vue&type=style&index=0&id=33ea96da&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ea96da",
  null
  
)

export default component.exports